import { createAction } from 'redux-actions';

import * as actionTypes from './actionTypes';

export const setInitialLoanType = createAction(
  actionTypes.SET_INITIAL_LOAN_TYPE,
  (loanType: LoanType | null) => loanType,
);

export const setOnboardingFormError = createAction(actionTypes.ONBOARDING_FORM_ERROR, (error: string) => error);
export const clearOnboardingFormError = createAction(actionTypes.ONBOARDING_FORM_ERROR, () => '');
